import './styles.scss'

import I18n from 'lib/i18n'

import React from 'react'
import { useValues } from 'kea'

import sceneLogic from '~/scenes/homepage/logic'

export default function MasterCategories () {
  const { categoryLinks: links } = useValues(sceneLogic)

  return (
    <>
      <div className='master-categories-responsive'>
        <h2
          className='master-categories-title'
          dangerouslySetInnerHTML={{ __html: I18n.t('homepage.master_categories.section_title') }}
        />
        <div className='master-categories-container'>
          {links.map(link => {
            return (
              <div key={link.id} className='master-category-card'>
                <a className='master-category-card-link' href={link.url} title={link.description}>
                  <img
                    className='rounded lazyload'
                    data-src={`/assets/master-categories/${link.keyword}.webp`}
                    alt={link.description}
                    width='600'
                    height='360'
                  />
                  <div className='master-category-card-body'>
                    <span className='master-category-title'>{link.title}</span>
                    <p className='master-category-teachers'>
                      {link.teacher_count
                        ? I18n.t('homepage.master_categories.title', { teachers_number: link.teacher_count })
                        : I18n.t('homepage.master_categories.no_teachers_title')}
                    </p>
                  </div>
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
